/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseMCPCallInProgressEvent = {
  type: "response.mcp_call.in_progress";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseMCPCallInProgressEvent$inboundSchema: z.ZodType<
  ResponseMCPCallInProgressEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.mcp_call.in_progress"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseMCPCallInProgressEvent$Outbound = {
  type: "response.mcp_call.in_progress";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseMCPCallInProgressEvent$outboundSchema: z.ZodType<
  ResponseMCPCallInProgressEvent$Outbound,
  z.ZodTypeDef,
  ResponseMCPCallInProgressEvent
> = z.object({
  type: z.literal("response.mcp_call.in_progress"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseMCPCallInProgressEventToJSON(
  responseMCPCallInProgressEvent: ResponseMCPCallInProgressEvent,
): string {
  return JSON.stringify(
    ResponseMCPCallInProgressEvent$outboundSchema.parse(
      responseMCPCallInProgressEvent,
    ),
  );
}
export function responseMCPCallInProgressEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseMCPCallInProgressEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseMCPCallInProgressEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseMCPCallInProgressEvent' from JSON`,
  );
}
